import { Flex } from '@pancakeswap/uikit'
import Content from "./component/Content"
import Suggest from "./component/Suggest"

const UserManual = () => {
    return (
        <Flex width="100%" style={{gap:"3rem"}} flexDirection={["column",,"row"]}>
            <Content />
            <Suggest />
        </Flex>
    )
}
export default UserManual
